// Logica della sezione telefonia del dialog GPT-Live, fuori dal componente
// per poterla testare (il frontend non ha test di mount).
const E164 = /^\+[1-9]\d{6,14}$/;
const ACCOUNT_SID = /^AC[0-9a-fA-F]{32}$/;
const ERR = 'botEditor.connectors.gptlive.telephony';

export function normalizePhoneNumber(input) {
  const compact = String(input || '').replace(/[\s().-]/g, '');
  const withPlus = compact.startsWith('00') ? `+${compact.slice(2)}` : compact;
  return E164.test(withPlus) ? withPlus : null;
}

export function linkedTelephony(connector) {
  const c = connector?.config;
  if (!c?.phoneNumber || c.telephonyProvider !== 'twilio') return null;
  return { number: c.phoneNumber, accountSid: c.twilioAccountSid || '', hasToken: c.hasTwilioAuthToken === true };
}

export function validateTelephonyForm({ accountSid, authToken, number, linked }) {
  const errors = {};
  const sid = String(accountSid || '').trim();
  if (!ACCOUNT_SID.test(sid)) errors.accountSid = 'invalidAccountSid';
  const reuseToken = !!(linked?.hasToken && linked.accountSid === sid);
  if (!String(authToken || '').trim() && !reuseToken) errors.authToken = 'authTokenRequired';
  if (!normalizePhoneNumber(number)) errors.number = 'invalidNumber';
  return { valid: Object.keys(errors).length === 0, errors };
}

export function buildTelephonyBody({ accountSid, authToken, number }) {
  const body = { provider: 'twilio', twilioAccountSid: String(accountSid || '').trim(), number: normalizePhoneNumber(number) };
  const token = String(authToken || '').trim();
  if (token) body.twilioAuthToken = token;
  return body;
}

const CODE_KEYS = {
  INVALID_ACCOUNT_SID: 'invalidAccountSid',
  INVALID_NUMBER: 'invalidNumber',
  AUTH_TOKEN_REQUIRED: 'authTokenRequired',
  TWILIO_AUTH_FAILED: 'twilioAuthFailed',
  NUMBER_NOT_FOUND: 'numberNotFound',
  NUMBER_IN_USE: 'numberInUse',
  NUMBER_ON_TRUNK: 'numberOnTrunk',
  NUMBER_ON_OTHER_ENVIRONMENT: 'numberOnOtherEnvironment',
  PUBLIC_URL_NOT_CONFIGURED: 'publicUrlNotConfigured',
  TWILIO_ERROR: 'twilioError',
  TELEPHONY_BUSY: 'telephonyBusy',
  TELEPHONY_DETACH_FAILED: 'detachFailed',
};

export function telephonyErrorKey(code) {
  return CODE_KEYS[code] ? `${ERR}.errors.${CODE_KEYS[code]}` : `${ERR}.error`;
}

// Avvisi di uno scollegamento riuscito (data.warnings). 'number_gone': il
// numero non esiste più su Twilio, scollegato solo in Crafter — merita un
// messaggio suo; gli altri codici (es. 'decrypt') restano nel log e
// all'utente arriva l'avviso generico.
export function unlinkWarningKey(warnings) {
  if (!Array.isArray(warnings) || !warnings.length) return null;
  return warnings.includes('number_gone') ? `${ERR}.unlinkNumberGone` : `${ERR}.unlinkWarnings`;
}
